/* globals gtag */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import "./Showcase.css"
import { /* useDispatch, */ useSelector } from "react-redux"
// import { SetSliderValue,SetUrlPrefix,SetImgPrefix,SetSliderValueMinMax,SetIsExpanded,SetIsSearching,SetSearchWord,SetPrevProducts,SetAsyncData,SetListingBanner,
//   SetProducts,SetResultsCount,SetFilters,SetMasterCategories,SetPages,SetPage,SetSuggestedWords,SetWordsHistory } from "../../state/actions/index";
import Utils from "../../utils/Utils"
import CategoriesContainer from "../CategoriesContainer/CategoriesContainer"
import ProductsRecommendations from "../ProductsRecommendations/ProductsRecommendations"
import CategoriesRecommendations from "../CategoriesRecommendations/CategoriesRecommendations"
import WordsHistory from "../WordsHistory/WordsHistory"
import PerfectScrollbar from "react-perfect-scrollbar"

export function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false)

  const observer = useMemo(
    () =>
      !!ref &&
      new IntersectionObserver(([entry]) =>
        setIntersecting(entry.isIntersecting)
      ),
    [ref]
  )

  useEffect(() => {
    if (
      !!ref &&
      observer instanceof IntersectionObserver &&
      ref.current instanceof Element
    ) {
      observer.observe(ref.current)
      return () => observer?.disconnect()
    }
  }, [ref, observer])

  return isIntersecting
}

const Showcase = () => {
  const triggers = useSelector((state) => state.config.triggers)
  const isMobile = useSelector((state) => state.isMobile)
  const promotionsFirstScreen = useSelector(
    (state) => state.config.promotions.firstScreen
  )
  const activeFilters = useSelector((state) => state.activeFilters)
  const searchWord = useSelector((state) => state.searchWord)
  const recommendationRules = useSelector(
    (state) => state.config.recommendationRules
  )
  const baseUrl = useSelector((state) => state.config.baseUrl)
  const shopId = useSelector((state) => state.config.shopId)
  const showcaseItems = useSelector((state) => state.config.showcaseItems)
  const isAutocompleteOpen = useSelector((state) => state.isAutocompleteOpen)
  const categoryTiles = useSelector(
    (state) => state.config.triggers.categoryTiles
  )
  const wordsHistory = useSelector((state) => state.wordsHistory)
  const autocomplete = useSelector((state) => state.config.autocomplete)
  const ga4 = useSelector((state) => state.config.ga4)

  const showcaseRef = useRef(null)
  const isPromViewed = useOnScreen(showcaseRef)
  useEffect(() => {
    if (isPromViewed) {
      Utils.sendAnalyticsObject(baseUrl, shopId, "as_view_promotion", {
        name: reactivePromotionsFirstScreen.name,
        type: "firt-screen",
        device: isMobile ? "mobile" : "desktop",
      })
      if (!!ga4?.isActive) {
        if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
          window.dataLayer.push({
            event: "as_view_promotion",
            data: {
              name: reactivePromotionsFirstScreen.name,
              type: "firt-screen",
              device: isMobile ? "mobile" : "desktop",
            },
          })
        } else if (typeof gtag !== "undefined") {
          gtag("event", "as_view_promotion", {
            name: reactivePromotionsFirstScreen.name,
            type: "firt-screen",
            device: isMobile ? "mobile" : "desktop",
          })
        }
      }
    }
  }, [isPromViewed])

  var minChars = useMemo(
    () =>
      isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop,
    [isMobile, autocomplete]
  )
  var reactivePromotionsFirstScreen = useMemo(
    () =>
      isMobile ? promotionsFirstScreen.mobile : promotionsFirstScreen.desktop,
    [isMobile, promotionsFirstScreen]
  )
  var wordsHistoryResponsive = useMemo(
    () =>
      isMobile ? triggers.wordsHistory.mobile : triggers.wordsHistory.desktop,
    [triggers, isMobile]
  )
  var isSearchwordShort = useMemo(
    () => searchWord.length < minChars,
    [searchWord, minChars]
  )

  var categoryTilesResponsive = useMemo(
    () => (isMobile ? categoryTiles.mobile : categoryTiles.desktop),
    [categoryTiles, isMobile]
  )
  var showcaseItemsResponsive = useMemo(
    () => (isMobile ? showcaseItems.mobile : showcaseItems.desktop),
    [showcaseItems, isMobile]
  )
  var showcaseItemsResponsiveDynamics = useMemo(
    () =>
      showcaseItemsResponsive.filter((item) =>
        item.value.startsWith("dynamic")
      ),
    [showcaseItemsResponsive]
  )
  var responsiveDynamicBannerId = useMemo(
    () =>
      isMobile
        ? "accelasearch-dynamic-showcase-mobile- "
        : "accelasearch-dynamic-showcase-",
    [isMobile]
  )

  var getParameterIndex = useCallback(
    (value) => {
      return showcaseItemsResponsive.findIndex((item) => item.value === value)
    },
    [showcaseItemsResponsive]
  )
  function handlePromotionClick() {
    sessionStorage.setItem("isLayerOpen", "false")
    Utils.sendAnalyticsObject(baseUrl, shopId, "as_click_promotion", {
      name: reactivePromotionsFirstScreen.name,
      type: "firt-screen",
      device: isMobile ? "mobile" : "desktop",
    })
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({
          event: "as_click_promotion",
          data: {
            name: reactivePromotionsFirstScreen.name,
            type: "firt-screen",
            device: isMobile ? "mobile" : "desktop",
          },
        })
      } else if (typeof gtag !== "undefined") {
        gtag("event", "as_click_promotion", {
          name: reactivePromotionsFirstScreen.name,
          type: "firt-screen",
          device: isMobile ? "mobile" : "desktop",
        })
      }
    }
  }

  function handleDynamicBlockClick(event) {
    Utils.sendAnalyticsObject(baseUrl, shopId, "as-dynamic-showcase-click", {
      dynamicBlockId: event.currentTarget.id,
      targetId: event.target.id,
      href: event.target.href ?? "",
    })
    if (!!ga4?.isActive) {
      if (typeof window.dataLayer !== "undefined" && !!window.dataLayer) {
        window.dataLayer.push({
          event: "as-dynamic-showcase-click",
          data: {
            dynamicBlockId: event.currentTarget.id,
            targetId: event.target.id,
            href: event.target.href ?? "",
          },
        })
      } else if (typeof gtag !== "undefined") {
        gtag("event", "as-dynamic-showcase-click", {
          dynamicBlockId: event.currentTarget.id,
          targetId: event.target.id,
          href: event.target.href ?? "",
        })
      }
    }
    const customEvent = new CustomEvent("as-dynamic-showcase-click", {
      detail: {
        dynamicBlockId: event.currentTarget.id,
        targetId: event.target.id,
        href: event.target.href ?? "",
      },
    })
    document.body.dispatchEvent(customEvent)
    sessionStorage.setItem("isLayerOpen", "false")
  }

  return (
    <PerfectScrollbar
      className={
        "first-screen" + (isAutocompleteOpen ? " autocompleteOpen" : "")
      }
    >
      {(activeFilters.length === 0 &&
        isSearchwordShort &&
        reactivePromotionsFirstScreen.isActive) ||
      isAutocompleteOpen ? (
        <div
          className="promo"
          style={{ order: getParameterIndex("banner") }}
          ref={showcaseRef}
        >
          <a
            href={reactivePromotionsFirstScreen.url}
            onClick={() => handlePromotionClick()}
          >
            <img
              src={reactivePromotionsFirstScreen.img}
              alt={reactivePromotionsFirstScreen.img}
            />
          </a>
        </div>
      ) : null}
      {/* {(activeFilters &&
        activeFilters.length === 0 &&
        isSearchwordShort &&
        recommendationRules?.length > 0) ||
      isAutocompleteOpen ? (
        <div style={{ order: getParameterIndex("recommendationsCategories") }}>
          {recommendationRules?.map((rule) => {
            if(rule?.isActive){
              if(rule?.tag === "layer"){
                return  <CategoriesRecommendations recommendation={rule} />
              } else {
                return <></>
              }
            }
          }
            
           
          )}
        </div>
      ) : null} */}
      {(activeFilters &&
        activeFilters.length === 0 &&
        isSearchwordShort &&
        wordsHistoryResponsive.isActive &&
        wordsHistory &&
        wordsHistory.length > 0) ||
      (isAutocompleteOpen && wordsHistoryResponsive.isActive) ? (
        <div style={{ order: getParameterIndex("lastSearches") }}>
          {" "}
          <WordsHistory />{" "}
        </div>
      ) : null}
      {(activeFilters &&
        activeFilters.length === 0 &&
        isSearchwordShort &&
        recommendationRules?.length > 0) ||
      isAutocompleteOpen ? (
        <div style={{ order: 1 }}>
          {recommendationRules?.map((rule) => {
            const timeCondition =
              rule?.condition?.conditions?.[0]?.conditions?.[0]
            let timeIntervalOk = false
            if (timeCondition?.type === "timeInterval") {
              if(timeCondition.from * 1000 <= new Date().getTime() && new Date().getTime() <= timeCondition.to * 1000){
                timeIntervalOk = true
              }
            } else {
              timeIntervalOk = true
            }

            if (rule?.isActive && !!timeIntervalOk) {
              if (rule?.tag === "layer") {
                const visualType = rule?.extra?.showcase?.visualizationType
                if (visualType === "carousel")
                  return <ProductsRecommendations recommendation={rule} />
                else {
                  // return <CategoriesRecommendations recommendation={rule} />
                  return <></>
                }
              } else {
                return <></>
              }
            }
          })}
        </div>
      ) : null}
      {(activeFilters &&
        activeFilters.length === 0 &&
        isSearchwordShort &&
        categoryTilesResponsive.length) ||
      (isAutocompleteOpen && categoryTilesResponsive) ? (
        <div style={{ order: getParameterIndex("mainCategories") }}>
          <CategoriesContainer />
        </div>
      ) : null}
      {activeFilters &&
      activeFilters.length === 0 &&
      isSearchwordShort &&
      showcaseItemsResponsiveDynamics.length > 0
        ? showcaseItemsResponsiveDynamics.map((item) => (
            <div
              style={{ order: getParameterIndex(item.value) }}
              key={item.value}
              id={responsiveDynamicBannerId + item.value?.split("-")[1]}
              onClick={(event) => handleDynamicBlockClick(event)}
            >
              {" "}
            </div>
          ))
        : null}
    </PerfectScrollbar>
  )
}

export default Showcase
